/**
 * Textos de la alerta que ve el equipo cuando el asistente necesita a una persona.
 * Sin términos técnicos: nada de "escalado", "bot", "IA" ni códigos de motivo.
 */

export const STAFF_CONSULTATION_REASON = 'staff_consultation'

export interface EscalationAlertCopy {
  badge: string
  title: string
  detail: string
  actionLabel: string
  /** El asistente sigue atendiendo y solo espera un dato; no es un traspaso del chat. */
  isConsultation: boolean
}

export function describeEscalationAlert(input: { reason?: string | null; summary?: string | null }): EscalationAlertCopy {
  const summary = input.summary?.trim() ?? ''

  if (input.reason === STAFF_CONSULTATION_REASON) {
    return {
      badge: 'Duda por resolver',
      title: 'Un cliente espera tu respuesta',
      detail: summary || 'El asistente necesita un dato que solo tu equipo tiene.',
      actionLabel: 'Responder',
      isConsultation: true,
    }
  }

  const friendlyReason = input.reason ? input.reason.replace(/_/g, ' ') : 'Atención personalizada requerida'
  return {
    badge: 'Asistente',
    title: 'Un cliente necesita atención de una persona',
    detail: friendlyReason,
    actionLabel: 'Atender',
    isConsultation: false,
  }
}
